class ReportsSerializer {
    public static instance = new ReportsSerializer();

    public serializeSummaryReports(response: any) {
        let data = {};
        if (response) {
            data = {
                studentCount : response.student_count,
                teacherCount : response.teacher_count,
                levels : {
                    level0: response.levels.level_0,
                    level1: response.levels.level_1,
                    level2: response.levels.level_2,
                    level3: response.levels.level_3,
                },
            };
        }
        return data;
    }

    public serializeSubjectList(response: any) {
        return response.subjects;
    }

    public serializeCompetencyDetails(response: any) {
        const competencyData: any = [];
        let data = response.data || [];
        data = data.sort((a: any, b: any) => {
            return a.grade_seq - b.grade_seq;
        });
        if (response.data) {
            response.data.forEach((item: any) => {
                let lowPercent = 0;
                let midPercent = 0;
                let highPercent = 0;
                const lowPercentCompentency: any = [];
                const midPercentCompetency: any = [];
                const highPercentCompetency: any = [];
                item.competencies.forEach((competency: any) => {
                    if (competency.mastery_percentage <= 40) {
                        lowPercent = lowPercent + 1;
                        lowPercentCompentency.push(competency);
                    }
                    if (competency.mastery_percentage > 40 && competency.mastery_percentage <= 75) {
                        midPercent = midPercent + 1;
                        midPercentCompetency.push(competency);
                    }
                    if (competency.mastery_percentage > 75) {
                        highPercent = highPercent + 1;
                        highPercentCompetency.push(competency);
                    }
                });
                const competencyDetails = {
                    gradeName: item.grade_name,
                    totalCompetency: item.total_comptency,
                    framework: item.framework,
                    competencies: item.competencies,
                    lowPercent,
                    midPercent,
                    highPercent,
                    lowPercentCompentency,
                    midPercentCompetency,
                    highPercentCompetency,
                };
                competencyData.push(competencyDetails);
            });
        }

        return competencyData;
    }
}

export const reportsSerializer = ReportsSerializer.instance;
